module.exports = __webpack_public_path__ + "static/media/ru.3a18b10c.svg";